import { useContext, useEffect } from "react";
import { WidgetContext } from "../../context/widgetContext";
import HtmlParsedText from "../common/HtmlParsedText";
import { TITLE } from "../../config/config";
import { CategoryContext, CategoryProvider } from "../../context/categoryContext";
import Body from "../common/Body";
import { Helmet } from "react-helmet";
import { generateHeadTags } from "react-seo-tools";
import StickyThreadList from "./section/StickyThreadList";
import Node from "../common/NodeTree/Node";
import LoadingContent from "../common/LoadingContent";

const SidebarContent = ({ setHasSidebar }) => {
	const { tag_cloud, fetchWidgetHtml } = useContext(WidgetContext);

	fetchWidgetHtml("tag_cloud");

	return (
		<>
			<div className="mb-4">
				{tag_cloud && <HtmlParsedText text={tag_cloud} />}
			</div>
		</>
	);
};

const HeroContent = () => {
	const { category } = useContext(CategoryContext);

	if (category) {
		return (
			<div className="px-2 pt-2 md:px-4 md:pt-4">
				<div className="flex items-center mb-2">
					<div>
						<h1 className="text-lg font-medium text-white">{category.title}</h1>
						<p className="text-sm text-url">{category.description}</p>
					</div>
				</div>
			</div>
		);
	} else {
		return null;
	}
};

const MainContent = () => {
	const { category, nodes, nodeTree, threadData } = useContext(CategoryContext);

	useEffect(() => {
		if (category) {
			document.title = `${category.title} | ${TITLE}`;
			document.querySelector("meta[name='description']").setAttribute("content", category.description);
		}
	}, [category]);

	return (
		<div>
			{category && (
				<Helmet>
					{generateHeadTags({
						title: category.title,
						description: category.description,
						openGraph: {
							type: "website",
							title: category.title,
						},
					})}
				</Helmet>
			)}

			{category && category.type_data.is_grid_view && nodes && nodes.length > 0 && (
				<section className="mb-4">
					<StickyThreadList nodes={nodes} threadData={threadData} />
				</section>
			)}

			{nodeTree && nodes && !category.type_data.is_grid_view && (
				<section className="mb-4 rounded-lg border border-borderColor overflow-hidden">
					<div className="node-container">
						<div className="node-body">
							{nodes.map((node, index) => (
								<Node key={index} node={node} />
							))}
						</div>
					</div>
				</section>
			)}
		</div>
	);
};

const CategoryViewRender = () => {
	const { fetchCategory, category, categoryLoading } = useContext(CategoryContext);

	useEffect(() => {
		fetchCategory();
	}, [fetchCategory]);

	if (category && !categoryLoading) {
		return (
			<Body
				mainContent={<MainContent />}
				heroContent={<HeroContent />}
				sidebarContent={!category.type_data.is_grid_view ? <SidebarContent /> : null}
			/>
		);
	} else {
		return <Body mainContent={<LoadingContent />} />;
	}
};

const CategoryView = () => {
	return (
		<CategoryProvider>
			<CategoryViewRender />
		</CategoryProvider>
	);
};

export default CategoryView;
